import MarkdownIt from 'markdown-it';

export const markdownRenderer = () => {
  const md = MarkdownIt({ breaks: true, linkify: true });

  const defaultRender =
    md.renderer.rules.link_open ||
    function (tokens, idx, options, env, self) {
      return self.renderToken(tokens, idx, options);
    };
  md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
    const targetIndex = tokens[idx].attrIndex('target');
    if (targetIndex < 0) {
      tokens[idx].attrPush(['target', '_blank']);
    } else {
      const attrs = tokens[idx].attrs;
      if (attrs) {
        attrs[targetIndex][1] = '_blank';
      }
    }

    const relIndex = tokens[idx].attrIndex('rel');
    if (relIndex < 0) {
      tokens[idx].attrPush(['rel', 'noopener']);
    } else {
      const attrs = tokens[idx].attrs;
      if (attrs) {
        attrs[relIndex][1] = 'noopener noreferrer';
      }
    }

    return defaultRender(tokens, idx, options, env, self);
  };

  return md;
};
